import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Ionicons } from '@expo/vector-icons';
import theme from '@/config/theme';

interface ProfileBrandingOnboardingProps {
  visible: boolean;
  userName?: string | null;
  onUpdateProfile: () => void;
  onDismiss: () => void;
}

const ProfileBrandingOnboarding: React.FC<ProfileBrandingOnboardingProps> = ({
  visible,
  userName,
  onUpdateProfile,
  onDismiss,
}) => {
  if (!visible) {
    return null;
  }

  const resolvedName = userName?.trim() || 'Seu nome';

  return (
    <LinearGradient colors={['#222327', '#383A40']} style={styles.card}>
      <View style={styles.headerRow}>
        <View style={styles.titleBlock}>
          <Text style={styles.pill}>Identificação</Text>
          <Text style={styles.title}>Atualize seu nome nos checklists</Text>
        </View>
        <TouchableOpacity
          style={styles.closeButton}
          onPress={onDismiss}
          accessibilityRole="button"
          accessibilityLabel="Fechar dica de perfil"
        >
          <Ionicons name="close" size={18} color="#FFFFFF" />
        </TouchableOpacity>
      </View>

      <Text style={styles.description}>
        Está vendo “{resolvedName}” lá no topo? Personalize seus dados para que clientes, seguradoras e equipe
        saibam quem criou cada checklist. Veja no histórico abaixo dos checklists, que exibe exatamente esse nome.
      </Text>

      <View style={styles.actionsRow}>
        <TouchableOpacity style={styles.primaryButton} onPress={onUpdateProfile}>
          <Text style={styles.primaryButtonText}>Atualizar meu perfil</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.secondaryButton} onPress={onDismiss}>
          <Text style={styles.secondaryButtonText}>Depois</Text>
        </TouchableOpacity>
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  card: {
    padding: theme.spacing.lg,
    borderRadius: theme.borderRadius.lg,
    ...theme.shadows.md,
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing.sm,
  },
  titleBlock: {
    flex: 1,
    minWidth: 0,
  },
  pill: {
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: theme.colors.primary.contrast,
    paddingHorizontal: theme.spacing.sm,
    paddingVertical: 2,
    borderRadius: theme.borderRadius.pill,
    fontSize: theme.fontSizes.xs,
    fontWeight: theme.fontWeights.medium as any,
    alignSelf: 'flex-start',
  },
  title: {
    marginTop: theme.spacing.xs,
    color: theme.colors.primary.contrast,
    fontSize: theme.fontSizes.xl,
    fontWeight: theme.fontWeights.semibold as any,
    lineHeight: 24,
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: 'rgba(255,255,255,0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    marginTop: theme.spacing.sm,
    color: 'rgba(255,255,255,0.92)',
    fontSize: theme.fontSizes.sm,
    lineHeight: 20,
  },
  actionsRow: {
    flexDirection: 'row',
    gap: theme.spacing.sm,
    marginTop: theme.spacing.md,
  },
  primaryButton: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    paddingVertical: theme.spacing.sm,
    borderRadius: theme.borderRadius.md,
    alignItems: 'center',
  },
  primaryButtonText: {
    color: '#1F2024',
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.semibold as any,
  },
  secondaryButton: {
    paddingVertical: theme.spacing.sm,
    paddingHorizontal: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.6)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  secondaryButtonText: {
    color: '#FFFFFF',
    fontSize: theme.fontSizes.sm,
    fontWeight: theme.fontWeights.medium as any,
  },
});

export default ProfileBrandingOnboarding;
